import { atom } from "recoil";

export const kycLoaderState = atom<boolean>({
  key: "KycLoaderState",
  default: false,
});
